import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

const routes: { [key: string]: string } = {
  '/': 'Ana Sayfa',
  '/ihtiyac-kredisi': 'İhtiyaç Kredisi',
  '/konut-kredisi': 'Konut Kredisi',
  '/tasit-kredisi': 'Taşıt Kredisi',
  '/kobi-kredisi': 'Kobi Kredisi',
  '/kredi-kartlari': 'Kredi Kartları',
  '/mevduat': 'Mevduat',
  '/uzaktan-musteri-edinimi': 'Uzaktan Müşteri Edinimi'
};

// Bank names mapping
const bankNames: { [key: string]: string } = {
  'akbank': 'Akbank',
  'garanti': 'Garanti BBVA',
  'yapikredi': 'Yapı Kredi',
  'qnb': 'QNB Finansbank',
  'isbankasi': 'İş Bankası',
  'ziraatbankasi': 'Ziraat Bankası',
  'nkolay': 'Nkolay'
};

const Breadcrumb = () => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter(x => x);
  
  // Don't show breadcrumb on homepage
  if (location.pathname === '/') return null;

  // Function to get breadcrumb name for a path segment
  const getBreadcrumbName = (segment: string, fullPath: string, index: number) => {
    // Check if it's a bank page pattern (e.g., /ihtiyac-kredisi/akbank)
    if (index === 1 && pathnames.length === 2) {
      // Second segment in a two-part path - likely a bank name
      return bankNames[segment] || segment;
    }
    
    // Check if it's a direct route
    if (routes[fullPath]) {
      return routes[fullPath];
    }
    
    // Check if it's a bank name
    if (bankNames[segment]) {
      return bankNames[segment];
    }
    
    // Default: capitalize first letter
    return segment.charAt(0).toUpperCase() + segment.slice(1);
  };
  return (
    <div className="bg-slate-900">
      <div className="container mx-auto px-4">
        <div className="py-0 md:py-3 flex items-center">
          <nav className="flex items-center gap-1 text-xs md:text-sm h-8 md:h-auto">
            <Link 
              to="/" 
              className="text-white hover:text-[#F7BA45] transition-colors inline-flex items-center gap-1 leading-none"
            >
              <Home size={12} className="md:w-4 md:h-4" />
              <span>Ana Sayfa</span>
            </Link>

            {pathnames.map((name, index) => {
              const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
              const isLast = index === pathnames.length - 1;
              const breadcrumbName = getBreadcrumbName(name, routeTo, index);

              return (
                <React.Fragment key={name}>
                  <ChevronRight size={12} className="text-slate-500 md:w-4 md:h-4" />
                  {isLast ? (
                    <span className="text-[#F7BA45] font-medium leading-none">
                      {breadcrumbName}
                    </span>
                  ) : (
                    <Link 
                      to={routeTo}
                      className="text-white hover:text-[#F7BA45] transition-colors inline-flex items-center leading-none"
                    >
                      {breadcrumbName}
                    </Link>
                  )}
                </React.Fragment>
              );
            })}
          </nav>
        </div>
      </div>
    </div>
  );
};

export default Breadcrumb;